import { render, staticRenderFns } from "./VGTable.vue?vue&type=template&id=2d2308d7"
import script from "./VGTable.vue?vue&type=script&lang=js"
export * from "./VGTable.vue?vue&type=script&lang=js"
import style0 from "./VGTable.vue?vue&type=style&index=0&id=2d2308d7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports